import getAngularService from './get_angular_service';

const redirect = (state: string, params: any = {}): Promise<any> => {
  const $state = getAngularService('$state');
  return $state.go(state, params);
};

export default redirect;
